module.exports = __webpack_public_path__ + "img/59.af91d0a5.jpg";